import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={468.361}
      height={247.18}
      viewBox="0 0 468.361 247.18"
      {...props}
    >
      <defs>
        <linearGradient
          id="prefix__d"
          x1={0.5}
          x2={0.5}
          y2={1}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#ffd71d" />
          <stop offset={1} stopColor="#feb200" />
        </linearGradient>
        <linearGradient
          id="prefix__a"
          x1={-0.694}
          y1={0.5}
          x2={0.308}
          y2={0.5}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#343a44" />
          <stop offset={0.3} stopColor="#232d3e" />
          <stop offset={0.64} stopColor="#182439" />
          <stop offset={1} stopColor="#142138" />
        </linearGradient>
        <linearGradient
          id="prefix__e"
          x1={0.15}
          y1={0.499}
          x2={1.15}
          y2={0.499}
          xlinkHref="#prefix__a"
        />
        <radialGradient
          id="prefix__c"
          cx={0.109}
          cy={0.359}
          r={0.627}
          gradientTransform="matrix(.683 0 0 1 .159 0)"
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <clipPath id="prefix__b">
          <rect
            data-name="Rectangle 1747"
            width={124.715}
            height={82.344}
            rx={14.22}
            fill="none"
          />
        </clipPath>
      </defs>
      <g data-name="Asset 1">
        <g data-name="Layer 2">
          <path
            data-name="Path 11232"
            d="M52.338 152.833c-23.645 14.869-36.024 48.369-16.906 93.025h376.589c6.393-16.175 10.212-37.43 11.419-50.078 2.62-27.594-6.762-56.264-23.3-71.4-41.848-38.314-76.635 14.907-98.642-7.577-12.7-12.986-11.526-49.417-21.431-66.338A101.206 101.206 0 00176.123 1.323c-27.087 4.4-51.53 18.734-66.438 43.032-20.417 33.227-5.548 57.025-14.6 79.993-10.012 25.554-26.949 18.58-42.747 28.485z"
            fill="rgba(242,177,143,0.3)"
          />
          <path
            data-name="Path 11233"
            d="M85.833 94.264a32.534 32.534 0 003.435-1.959L90.743 90s1.445-.93 2.482-1.429 2.935-3.6 2.935-3.6l-.768-.945a12.564 12.564 0 01-1.445 1.537 1.86 1.86 0 01-1.083 0 19.155 19.155 0 01.838-2.305 21.278 21.278 0 012.344-3.589l-.669-.7a18.142 18.142 0 00-1.437 1.537c-.384.507-1.114 1.537-1.114 1.537a21.326 21.326 0 011.229-2.567c.476-.7.984-1.644.984-1.644l-.768-.53a17.436 17.436 0 00-1.352 1.936c-.461.83-1.314 2.2-1.314 2.2a26.837 26.837 0 01.968-2.713 8.833 8.833 0 00.438-.914l-.907-.315a7.415 7.415 0 00-1.068 1.921A11.081 11.081 0 0190.344 81a10.475 10.475 0 01.569-2.305 2.013 2.013 0 00.307-.768l-.768-.138s-1.414 2.6-2.152 4.219-1.329 3.8-1.744 4.972a45.5 45.5 0 00-.968 5.2z"
            fill="#f5c5b3"
          />
          <path
            data-name="Path 11234"
            d="M107.619 109.725l-17.9-3.074a59.622 59.622 0 01-.192-9.175c.315-5.379.968-6.847.968-6.847l-4.8-.669s-.945 4.219-1.629 7.254c-1.537 6.724-2.882 13.025-1.729 14.423 1.667 2.036 16.567 6.147 21.662 9.99 3.057 2.314 2.881-5.056 3.62-11.902z"
            fill="#165a9f"
          />
          <path
            data-name="Path 11235"
            d="M132.999 160.625l-.907 6.193 1.867 4.242 1.368-1.852.315-3.458 2.021.307.991-1.245-.085-2.6-.33-7.054z"
            fill="#fec4ad"
          />
          <path
            data-name="Path 11236"
            d="M131.739 113.429c-1.375-.507-5.878-.177-5.878-.177a18.554 18.554 0 001.406 8.522c1.829 3.711 6.355 17.228 6.916 18.5S133 160.599 133 160.599l6.57-1.352s3.174-14.715 3.151-18.442-3.527-17.743-6.017-22.207-1.615-3.932-4.965-5.169z"
            fill="#165a9f"
          />
          <path
            data-name="Path 11237"
            d="M120.904 99.666s-1.445 6.347-.307 7.823c.661.861 3.473 3.942 3.473 3.942s-9.313 4.918-12.057 4.918-1.775-5.487-1.775-5.487 2.981-2.367 3.427-3.558a26.624 26.624 0 00.692-4.611z"
            fill="#fec4ad"
          />
          <path
            data-name="Path 11238"
            d="M121.995 99.897s-.1-2.305 1.829-2.251c1.237 0 1.337 1.168.369 2.628-.4.615-.446 2.006-.945 2.459s-1.122-.3-1.314-.684a4.611 4.611 0 01.061-2.152z"
            fill="#f5c5b3"
          />
          <path
            data-name="Path 11239"
            d="M111.567 99.897s.108-2.305-1.829-2.251c-1.237 0-1.329 1.168-.369 2.628.407.615.446 2.006.953 2.459s1.122-.3 1.306-.684a4.61 4.61 0 00-.061-2.152z"
            fill="#f5c5b3"
          />
          <path
            data-name="Path 11240"
            d="M123.962 94.248a22.393 22.393 0 01-.392 2.351c-.046.269-.1.576-.146.93-.4 2.774-.907 6.547-1.13 7.108-.361.93-2.344 2.444-3.281 3a5.656 5.656 0 01-4.249-.115c-.937-.553-3.074-1.952-3.427-2.882-.223-.576-.768-4.457-1.153-7.277a19.35 19.35 0 00-.138-.845 22.45 22.45 0 01-.377-2.267c-.146-2.344 2.49-5.755 7.146-5.755 5.503-.003 7.293 3.409 7.147 5.752z"
            fill="#f5c5b3"
          />
          <path
            data-name="Path 11241"
            d="M111.998 91.298a11.119 11.119 0 018.522.307l1.644-1.045a13.463 13.463 0 00-5.832-1.229c-3.443.03-4.334 1.967-4.334 1.967z"
            fill="#e8d4e5"
          />
          <path
            data-name="Path 11242"
            d="M123.57 96.6c-.046.269-.1.576-.146.93-.4 2.774-.907 6.547-1.13 7.108-.361.93-2.344 2.444-3.281 3a5.656 5.656 0 01-4.249-.115c-.937-.553-3.074-1.952-3.427-2.882-.223-.576-.768-4.457-1.153-7.277a19.35 19.35 0 00-.138-.845l.384-.561s.684 4.019 1.737 5.264 1.245 1.306 1.245 1.306l2.152-.53h.169a5.025 5.025 0 012.505 0l.131.038.161.046 1.621.469s.384-.054 1.429-1.306 1.537-5.264 1.537-5.264z"
            fill="#7b2b1a"
          />
          <path
            data-name="Path 11243"
            d="M124.3 92.751c0 .077-.4 2.812-.553 3.25a129.16 129.16 0 01-.415 1.137l-.284-.607a9.09 9.09 0 01-.83-3.619l-.054-2.351.768-.692c1.552.231 1.722 1.122 1.368 2.882z"
            fill="#7b2b1a"
          />
          <path
            data-name="Path 11244"
            d="M112.089 90.673l-.377 2.421a9.052 9.052 0 01-1.122 3.181v.054l-.423.768s-.131-.43-.307-1.037c-.123-.446-.446-2.736-.523-3.074a1.881 1.881 0 00-.061-.3c-.33-1.714 0-2.436 1.537-2.666z"
            fill="#7b2b1a"
          />
          <path
            data-name="Path 11245"
            d="M122.947 89.908l-.768.692-1.491.538a11.711 11.711 0 00-5.241-.945c-2.981.231-3.389 1.091-3.435 1.145l-.307-.069-1.468-.315-.3-.069a9.776 9.776 0 01.584-1.66c1.176-1.767 4.365-2.912 7.269-2.62h.292a6.993 6.993 0 013.95 1.629z"
            fill="#7b2b1a"
          />
          <path
            data-name="Path 11246"
            d="M130.209 240.395v5.809h-11.165s.415-2.1 5.709-3.074l.768-2.736z"
            fill="#133a50"
          />
          <path
            data-name="Path 11247"
            d="M113.227 240.395v5.809h-11.173s.423-2.1 5.717-3.074l.768-2.736z"
            fill="#133a50"
          />
          <path
            data-name="Path 11248"
            d="M128.327 153.909s1.537 18.711 1.614 33.972.961 53.843.961 53.843h-6.147s-6.355-37.053-8.66-46.874-8.314-40.765-8.314-40.765z"
            fill="#133a50"
          />
          <path
            data-name="Path 11249"
            d="M114.933 174.003s-1.16 23.252-1.391 27.832 0 39.866 0 39.866-5.771.161-5.771 0-5.448-37.576-6.147-48.856-.292-24.659-1.229-26.219 2.528-12.641 2.528-12.641l8.176 2.175z"
            fill="#133a50"
          />
          <path
            data-name="Path 11250"
            d="M112.412 108.749s-2.559 5.809 1.3 6.455c6.147 1.014 7.992-6.824 7.992-6.824l6.754 3.481s-.131 42.048 2.528 54.888c1.537 7.454-24.105 3.9-27.871-2.713-3.258-5.725 6.147-53.305 6.147-53.305z"
            fill="#fff"
          />
          <path
            data-name="Path 11251"
            d="M123.29 109.118c-.184.254-9.221 26.772-6.147 51.73.722 5.817 11.334 1.007 13.832 1.007 0 0 1.206-18.627 1.5-25.55s-3-9.221-2.713-12.594 3.98-9.436 3.98-9.436z"
            fill="#165a9f"
          />
          <path
            data-name="Path 11252"
            d="M108.14 163.484c1.037-17.351 1.46-53.667 1.46-53.667l-6.147-.453s-3.074 30.46-3.074 33.918c0 1.383.415 18.1-.515 21.239 2.059.308 8.153 1.053 8.276-1.037z"
            fill="#165a9f"
          />
          <path
            data-name="Path 11253"
            d="M174.816 99.666c-4.81 1.644-9.744 3.373-13.563 6.724s-6.278 8.783-4.664 13.6 8.3 7.623 12.172 4.334c1.391-1.176 2.251-3.2 1.537-4.872-1.475-3.289-6.624-1.752-9.037.937-2.859 3.181-4.68 7.538-3.973 11.757s4.4 8.015 8.675 8.015 10.381-6.462 6.716-8.675c-4.649-2.812-10.635 3.842-12.925 8.814s-.853 11.6 3.842 14.377 15.653-.768 12.779-5.379c-3.074-4.879-12.018 2.152-13.209 7.776a10.825 10.825 0 008.914 12.471c5.709.692 15.584-5.8 11.634-9.989-5.7-6.024-15.215 9.329-12.471 17.167s14.093 10.95 20.455 5.625c1.191-1 2.267-2.428 2.044-3.973-.361-2.559-3.842-3.281-6.332-2.459-6.409 2.136-9.306 11.111-5.379 16.6s13.378 5.586 17.435.184a4.61 4.61 0 001.122-3.658c-.4-1.8-2.528-2.812-4.334-2.474a7.077 7.077 0 00-4.3 3.227 13.181 13.181 0 0020.478 16.46c1.176-1.237 2.144-2.9 1.829-4.572a4.308 4.308 0 00-4.4-3.181 7.684 7.684 0 00-5.141 2.59c-5.732 5.963-3.281 17.5 4.388 20.6s22.876-5.448 17.489-11.734c-3.6-4.2-10.689 4.88-9.782 10.335s7.177 9.16 12.525 7.761 12.349-9.052 8.222-12.74c-2.92-2.6-7.684 2.9-8.553 6.7a8.968 8.968 0 004.611 9.828c3.773 1.86 8.4.768 12.034-1.383s6.647-5.164 10.143-7.507a31.767 31.767 0 0124.244-4.541"
            fill="none"
            stroke="#fff"
            strokeMiterlimit={10}
            strokeWidth={2}
          />
          <path
            data-name="Path 11254"
            d="M417.3 124.702c-7.784-4.964-77.165 53.521-74.621 99.734 0 0 13.509-18.242 25.281-27.133s12.917-18.2 12.894-27.41 17.589-5.379 19.572-15.63c3.503-18.089 23.882-25.089 16.874-29.561z"
            fill="#4fae86"
          />
          <path
            data-name="Path 11255"
            d="M421.864 167.756c-11.2 6.785-7.907 15.837-14.516 21.124-4.81 3.842-12.825 1.837-16.828 7.069-4.5 5.9.622 14.016 1 21.132.523 9.82-8.237 17.182-17.136 20.171-10.343 3.466-23.721 2.382-29.377-7.9-6.678-12.133-1.683-30.422 10.036-36.116 2.851-1.383 6.462-1.76 8.791-4.557 3.919-4.733 1.406-11.526 3.22-17.551 1.775-5.863 7.569-9.99 12.909-11.811s10.758-2.2 16-4.319c7.108-2.889 13.332-9.221 19.249-13.509 5.276-3.84 23.816-10.971 26.816 1.539 2.742 11.426-10.751 19.026-20.164 24.728z"
            fill="#319188"
          />
          <path
            data-name="Path 11256"
            d="M423.017 149.514s-45.821 23.053-82.375 97.321"
            fill="none"
            stroke="#194459"
            strokeMiterlimit={10}
          />
          <path
            data-name="Path 11257"
            d="M450.684 184.216s-58.907-.653-107.856 55.5"
            fill="none"
            stroke="#fff"
            strokeMiterlimit={10}
          />
          <path
            data-name="Path 11258"
            d="M421.472 210.488c-5.617 2.244-7.139 11.711-13.186 12.909-4.4.876-9.09-3.02-13.386-1-4.849 2.305-4 9.106-5.971 13.747-2.736 6.409-10.865 8.23-17.712 7.216-7.945-1.168-16.49-6.224-17.021-14.6-.622-9.89 8.453-19.871 18-19.664 2.305.046 4.841.991 7.262 0 4.088-1.729 4.549-6.87 7.646-10.1s8.161-3.842 12.295-3.289 7.846 2.121 11.972 2.474c5.625.492 11.749-1.537 17.013-2.305 4.7-.7 23.913-.33 17.328 9.728-4.568 6.951-16.763 1.872-24.24 4.884z"
            fill="#4fae86"
          />
          <path
            data-name="Path 11259"
            d="M433.583 201.213s-40.919 3.481-88.507 38.736"
            fill="none"
            stroke="#194459"
            strokeMiterlimit={10}
          />
          <path
            data-name="Path 11260"
            d="M300.246 245.205s9.313-16.3 10.827-17.981c9.582-10.6 22.284-10.719 35.225-8.045 3.742.768 13.647 5.986 17.243 5.264 2.8-.561 6.147-11.2 15.123-10.643s9.505 11.2 9.505 11.2 5.625-12.364 14.6-11.227 8.967 9.49 2.244 15.684c0 0 14.285-4.288 28.147 2.351s7.246 15.368 7.246 15.368z"
            fill="#319188"
          />
          <path
            data-name="Path 11261"
            d="M51.062 124.702c7.784-4.964 77.165 53.521 74.622 99.734 0 0-13.509-18.242-25.281-27.133s-12.925-18.2-12.9-27.41-17.584-5.382-19.566-15.63c-3.512-18.089-23.886-25.089-16.875-29.561z"
            fill="#4fae86"
          />
          <path
            data-name="Path 11262"
            d="M46.497 167.756c11.211 6.785 7.915 15.837 14.523 21.124 4.8 3.842 12.825 1.837 16.821 7.069 4.511 5.9-.615 14.016-.991 21.132-.523 9.82 8.237 17.182 17.136 20.171 10.335 3.466 23.714 2.382 29.377-7.9 6.678-12.133 1.675-30.422-10.043-36.116-2.843-1.383-6.455-1.76-8.783-4.557-3.927-4.733-1.406-11.526-3.22-17.551-1.775-5.863-7.569-9.99-12.91-11.811s-10.758-2.2-16-4.319c-7.108-2.889-13.332-9.221-19.211-13.509-5.277-3.84-23.819-10.971-26.824 1.539-2.781 11.426 10.712 19.026 20.125 24.728z"
            fill="#319188"
          />
          <path
            data-name="Path 11263"
            d="M45.337 149.514s45.813 23.053 82.367 97.321"
            fill="none"
            stroke="#194459"
            strokeMiterlimit={10}
          />
          <path
            data-name="Path 11264"
            d="M17.674 184.216s58.915-.653 107.863 55.5"
            fill="none"
            stroke="#fff"
            strokeMiterlimit={10}
          />
          <path
            data-name="Path 11265"
            d="M46.874 210.488c5.617 2.244 7.139 11.711 13.186 12.909 4.4.876 9.09-3.02 13.386-1 4.841 2.305 3.988 9.106 5.971 13.747 2.736 6.409 10.858 8.23 17.674 7.216 7.953-1.168 16.49-6.224 17.028-14.6.622-9.89-8.453-19.871-18-19.664-2.305.046-4.841.991-7.262 0-4.1-1.729-4.557-6.87-7.684-10.1s-8.161-3.842-12.295-3.289-7.846 2.121-11.972 2.474c-5.625.492-11.749-1.537-17.021-2.305-4.7-.7-23.906-.33-17.32 9.728 4.652 6.951 16.84 1.872 24.309 4.884z"
            fill="#4fae86"
          />
          <path
            data-name="Path 11266"
            d="M34.779 201.213s40.919 3.481 88.5 38.736"
            fill="none"
            stroke="#194459"
            strokeMiterlimit={10}
          />
          <path
            data-name="Path 11267"
            d="M168.116 245.205s-9.313-16.3-10.835-17.981c-9.575-10.6-22.284-10.719-35.217-8.045-3.742.768-13.655 5.986-17.243 5.264-2.8-.561-6.147-11.2-15.13-10.643S80.186 225 80.186 225s-5.617-12.364-14.6-11.227-8.96 9.49-2.236 15.684c0 0-14.285-4.288-28.155 2.351s-7.242 15.372-7.242 15.372z"
            fill="#319188"
          />
          <path
            data-name="Path 11268"
            d="M268.47 246.664h-14.491a3.074 3.074 0 01-3.074-2.82l-.945-11.442h22.51l-.953 11.442a3.074 3.074 0 01-3.047 2.82z"
            fill="#21295b"
          />
          <path
            data-name="Path 11269"
            d="M354.035 246.664h-14.492a3.074 3.074 0 01-3.074-2.82l-.945-11.442h22.56l-.945 11.442a3.074 3.074 0 01-3.1 2.82z"
            fill="#21295b"
          />
          <path
            data-name="Path 11270"
            d="M356.548 217.358H251.466l7.431-54.174a8.529 8.529 0 018.453-7.377h73.308a8.545 8.545 0 018.453 7.377z"
            fill="#ff3a46"
          />
          <path
            data-name="Path 11271"
            d="M342.363 206.846h-76.719l5.456-54.42a7.907 7.907 0 017.838-7.123h50.1a7.915 7.915 0 017.876 7.125z"
            fill="#ff3a46"
          />
          <path
            data-name="Path 11272"
            d="M253.149 205.055l-1.683 12.3h105.082l-1.691-12.3z"
            fill="#cfcfcf"
          />
          <path
            data-name="Path 11273"
            d="M367.921 238.374H240.094l2.367-27.771h123.093z"
            fill="#ff3a46"
          />
          <circle
            data-name="Ellipse 591"
            cx={23.383}
            cy={23.383}
            r={23.383}
            transform="rotate(-33.07 426.016 -371.352)"
            fill="#cfcfcf"
          />
          <circle
            data-name="Ellipse 592"
            cx={20.225}
            cy={20.225}
            r={20.225}
            transform="rotate(-1.34 6957.664 -12033.778)"
            fill="#fff"
          />
          <path
            data-name="Path 11274"
            d="M309.675 195.796a2.613 2.613 0 01-1.86-.768 1.8 1.8 0 01-.323-.4 2.168 2.168 0 01-.246-.453 3.538 3.538 0 01-.154-.484 3.01 3.01 0 01-.054-.523 2.628 2.628 0 013.143-2.566 2.258 2.258 0 01.492.146 3.6 3.6 0 01.453.238 3.379 3.379 0 01.4.33 2.674 2.674 0 01.768 1.852 4 4 0 01-.046.522 3.552 3.552 0 01-.154.484 3.185 3.185 0 01-.238.453 2.4 2.4 0 01-.33.4 2.3 2.3 0 01-.4.323 1.99 1.99 0 01-.453.246 2.775 2.775 0 01-.492.146 2.305 2.305 0 01-.507.054z"
            fill="#b3b3b3"
          />
          <path
            data-name="Path 11275"
            d="M301.521 196.718a2.62 2.62 0 01-2.228-2.966 2.613 2.613 0 012.966-2.228 2.62 2.62 0 012.228 2.966 2.628 2.628 0 01-2.6 2.259 1.992 1.992 0 01-.366-.031zm-8.453-3.581a2.636 2.636 0 01-.453-3.7 2.628 2.628 0 013.681-.446 2.62 2.62 0 01.453 3.681 2.605 2.605 0 01-2.075 1.014 2.628 2.628 0 01-1.591-.553zm-5.517-7.338a2.613 2.613 0 011.452-3.412 2.628 2.628 0 013.42 1.445 2.636 2.636 0 01-1.46 3.419 2.605 2.605 0 01-.984.192 2.613 2.613 0 01-2.413-1.644zm1.114-6.147a2.62 2.62 0 01-2.236-2.966 2.62 2.62 0 012.966-2.228 2.62 2.62 0 012.236 2.966 2.628 2.628 0 01-2.6 2.251 2.873 2.873 0 01-.354-.015zm1.8-7.715a2.628 2.628 0 01-.461-3.681 2.62 2.62 0 013.688-.461 2.628 2.628 0 01.453 3.688 2.62 2.62 0 01-2.067 1.007 2.6 2.6 0 01-1.615-.553zm21.193-2.613a2.62 2.62 0 01-.453-3.681 2.62 2.62 0 013.681-.461 2.636 2.636 0 01.461 3.688 2.643 2.643 0 01-2.075 1.014 2.659 2.659 0 01-1.591-.561zm-15.771-3.174a2.62 2.62 0 011.445-3.419 2.628 2.628 0 013.42 1.452 2.628 2.628 0 01-1.452 3.419 2.72 2.72 0 01-.984.184 2.6 2.6 0 01-2.405-1.637zm9.813.653a2.628 2.628 0 01-2.228-2.966 2.62 2.62 0 012.966-2.228 2.62 2.62 0 012.236 2.966 2.636 2.636 0 01-2.6 2.251z"
            fill="#b3b3b3"
          />
          <path
            data-name="Path 11276"
            d="M318.012 176.148a2.765 2.765 0 01-.507-.054 2.688 2.688 0 01-.5-.154 2.48 2.48 0 01-.446-.238 2.831 2.831 0 01-.407-.33 2.643 2.643 0 01-.768-1.852 2.344 2.344 0 01.054-.515 2.311 2.311 0 01.154-.492 2.554 2.554 0 01.238-.453 2.72 2.72 0 01.323-.4 2.349 2.349 0 01.438-.3 2.306 2.306 0 01.446-.246 2.677 2.677 0 01.5-.146 2.643 2.643 0 012.359.715 2.03 2.03 0 01.33.4 2.13 2.13 0 01.238.453 2.3 2.3 0 01.154.492 2.347 2.347 0 01.054.515 2.651 2.651 0 01-2.628 2.628z"
            fill="#b3b3b3"
          />
          <path
            data-name="Path 11277"
            d="M273.85 93.98a11.2 11.2 0 012.254-11.757s19.018 12.295 40.273 8.845c0 0 2.305 6.409-4.2 12.349-.006.03-22.759 4.341-38.327-9.437z"
            fill="#f7b686"
          />
          <path
            data-name="Path 11278"
            d="M306.409 66.709c-13.686-11.526-39.612-13.163-72.424-7.884-28.216 4.541-56.948 15.2-66.538 30.253-4.372 6.854-1.406 25.9-1.406 25.9 26 1.629 35.516-20.747 35.516-20.747s-1.744-6.339 4.08-9.144c20.379-9.774 51.968-13.125 63.718-10.228a8.7 8.7 0 016.747 7.4s16.052 18.227 40.219 8.529c0-.005-3.704-18.839-9.912-24.079z"
            fill="#cf1e22"
          />
          <path
            data-name="Path 11279"
            d="M206.867 104.507a11.227 11.227 0 00-5.825-10.435s-14.185 17.674-35.463 21.039c0 0-.2 6.824 7.869 10.4.001-.034 22.961-3.077 33.419-21.004z"
            fill="#f7b686"
          />
          <g
            data-name="Group 629"
            transform="translate(87.877 164.152)"
            clipPath="url(#prefix__b)"
          >
            <rect
              data-name="Rectangle 1746"
              width={124.715}
              height={82.344}
              rx={14.22}
              fill="#ffd71d"
            />
            <path
              data-name="Path 11280"
              d="M124.715 10.927A10.927 10.927 0 00113.788 0H10.927A10.927 10.927 0 000 10.927L56.587 56.78a9.121 9.121 0 0011.473 0z"
              fill="#ffb921"
            />
            <path
              data-name="Path 11281"
              d="M121.637 287.471v-60.5a10.935 10.935 0 0110.927-10.935h102.377a10.873 10.873 0 00-6.793-2.428H125.287a10.927 10.927 0 00-10.927 10.927v60.49a10.927 10.927 0 0010.927 10.935h.484a10.881 10.881 0 01-4.134-8.489z"
              transform="translate(-114.36 -213.618)"
              opacity={0.7}
              fill="url(#prefix__c)"
            />
            <path
              data-name="Path 11282"
              d="M169.825 262.43l-55.465-48.81h124.715l-55.465 48.81a10.435 10.435 0 01-13.786 0z"
              transform="translate(-114.36 -213.62)"
              fill="url(#prefix__d)"
            />
            <path
              data-name="Path 11283"
              d="M55.465 48.81L0 0h124.715L69.25 48.81a10.435 10.435 0 01-13.786 0z"
              fill="#fd0"
              opacity={0.7}
            />
          </g>
          <path
            data-name="Path 11284"
            d="M249.914 114.343s3.55-10.243 3.8-11.373c1.468-6.655 1.867-21.086 1.775-24.159s-.376-5.763-.438-6.147a14.863 14.863 0 00-1.967-2.436 3.966 3.966 0 01-.592.061v.383l-.845-.745h-.692l-.069.323-.976-.469h-.945s.607 1.944.953 3.127 0 1.283 0 1.283a2.543 2.543 0 01-1.053.2 7.415 7.415 0 00-1.337-.061s2.859 3.727 3 4.073a6.778 6.778 0 011.153 5.379 138.313 138.313 0 01-4.088 14.915c.092-.207-3.842 11.058-3.842 11.058z"
            fill="#fec4ad"
          />
          <path
            data-name="Path 11285"
            d="M248.001 127.899c1.1-8.622 5.517-18.688 5.517-18.688s-6.747-1.337-8.453-3.735c0 0-2.305 5.679-3.665 8.5-1.475 3.12-3.55 6.524-.945 8.376s7.169 8.551 7.546 5.547z"
            fill="#165a9f"
          />
          <path
            data-name="Path 11286"
            d="M222.166 241.048v5.54h10.666s-.4-2.006-5.456-2.928l-.768-2.613z"
            fill="#133a50"
          />
          <path
            data-name="Path 11287"
            d="M238.365 241.048v5.54h10.65s-.4-2.006-5.448-2.928l-.768-2.613z"
            fill="#133a50"
          />
          <path
            data-name="Path 11288"
            d="M223.957 158.55s-1.491 15.484-1.537 30.045-.922 53.72-.922 53.72h5.878s6.063-37.707 8.268-47.066 7.945-36.531 7.945-36.531z"
            fill="#133a50"
          />
          <path
            data-name="Path 11289"
            d="M232.993 107.181s-.384 2.966-.692 4.472a12.2 12.2 0 01-.807 2.766 33.461 33.461 0 01-3.635 4.126s9.751 5.148 12.61 5.148 1.867-5.748 1.867-5.748-3.128-2.467-3.6-3.719a28.334 28.334 0 01-.722-4.856z"
            fill="#fec4ad"
          />
          <path
            data-name="Path 11290"
            d="M236.736 175.356s1.107 24.543 1.322 28.908 0 38.037 0 38.037 5.51.146 5.51 0 5.195-38.214 5.871-48.979.3-23.5 1.168-25.035-2.405-9.667-2.405-9.667l-7.792-.284z"
            fill="#133a50"
          />
          <path
            data-name="Path 11291"
            d="M229.843 115.649s-8.222-3.3-9.59-.592c-1.022 2.052-.138 15.222.315 18.9.4 3.2 2.613 30.13 2.613 30.13s3.074 4.764 17.881 2.866c5.709-.73 8.514-3.512 8.514-3.512s-1.6-32.128-2.044-35.347a69.394 69.394 0 00-1.959-8.253l-4.411-2.9s1.406 3.074-2.567 3.98c-8.014 1.775-8.752-5.272-8.752-5.272z"
            fill="#165a9f"
          />
          <path
            data-name="Path 11292"
            d="M240.786 95.978c.93.377 2.559 1.222 2.743 2a30.459 30.459 0 01.93 4.4c.085 1.368.284 3.957.277 5.571a14.316 14.316 0 01-1.337 5.218 8.022 8.022 0 01-4 .645c-.914-.261-6.286-3.074-6.624-6.447 0 0-.953.5-2.7-2.305-.461-.768 1.114-6.24 1.329-7.223.515-2.374 6.386-.5 7.684-.876a2.874 2.874 0 001.691-.984z"
            fill="#fec4ad"
          />
          <path
            data-name="Path 11293"
            d="M243.529 97.975s-4.119 2.574-5.725 2.713-3.957 2.305-3.919 3.02a1.475 1.475 0 01-.676 1.153s-1-1.591-1.813-1.422c-1.621.323-.669 2.305.207 2.766a13.675 13.675 0 001.737.707 8.578 8.578 0 01.077 1.721 7.891 7.891 0 01-.684 2.006s-1.9-4-3.6-5.494c-4.05-3.542-1.122-10.135 2.874-11.38 1.606-.5 6.032-.83 8.184.138a5.871 5.871 0 013.343 4.073z"
            fill="#133a50"
          />
          <path
            data-name="Path 11294"
            d="M234.907 103.608c.061.161.484.192.561.231s.092.1.838 1.229c.546.838 1.46 1.107 3.174.538 1.306-.438 1.122-1.537 1.214-2.1s.207-.622.415-.661.323 0 .592.484.392 1.691 1.76 1.483c.945-.138 1.191-.4 1.314-1.145a7.591 7.591 0 00.108-1.806c0-.492-.046-.768-.292-.815a4.064 4.064 0 00-1.122.123 4.418 4.418 0 00-1.844.476c-.446.323-.392.515-.622.561s-.284-.161-.807-.307a15.968 15.968 0 00-3.512.369c-.815.146-1.929.453-1.906.768a2.127 2.127 0 00.129.572zm7.039-1.206c.046-.4.077-.361 1.083-.592s1.107-.184 1.314 0a2.144 2.144 0 01.246 1.629 1.107 1.107 0 01-.968 1.16c-.891.161-1.1-.284-1.345-.9a3.726 3.726 0 01-.33-1.297zm-5.871.653a7.752 7.752 0 012.528-.53c.991-.123 1.368-.169 1.537.192a3.787 3.787 0 01.123 1.314c0 .661-.154 1.245-1.752 1.537a1.721 1.721 0 01-2.136-.953 1.9 1.9 0 01-.3-1.56zm-3.42 1.014l2.251-.461.768-1.107s-.861.123-2.305.438a4.534 4.534 0 00-1.36.638 2.251 2.251 0 01.646.492z"
            fill="#21295b"
          />
          <path
            data-name="Path 11295"
            d="M214.912 115.265s-1.944-12.333-1.967-13.486c-.108-6.816 3.35-15.976 4.05-18.965s1.176-2.513 1.314-2.9 5.095-1.153 5.095-1.153a13.328 13.328 0 011.637-.584 11.572 11.572 0 001.621-.423l-.745 1.4s-3.074 2.305-3.289 2.659a6.747 6.747 0 00-2.205 5.056c-.123 6.094-.108 12.7-.108 12.7-.046-.223 2.92 12.633 2.92 12.633z"
            fill="#fec4ad"
          />
          <path
            data-name="Path 11296"
            d="M220.538 133.953c-2.09-5.94-6.916-21.908-6.916-21.908s7.123-1.79 9.137-3.965c0 0 2.4 7.131 3.4 10.089 1.107 3.281 2.774 6.916 0 8.453s-4.584 10.159-5.621 7.331z"
            fill="#165a9f"
          />
          <path
            data-name="Path 11297"
            d="M459.85 186.445c1.852 1.721 3.158 1.145 5.94 10.65 1.775 6.071 8.245 36.708 8.245 36.708l-3.842 1.675c-5.233-14.6-5.225-14.6-11.334-26.511a52.677 52.677 0 01-4.2-11.442l-11.3-.676c-7.054-2.9-4.611-13.209-4.611-13.209s19.252 1.083 21.102 2.805z"
            transform="translate(-101.511 -42.525)"
            fill="url(#prefix__a)"
          />
          <path
            data-name="Path 11298"
            d="M409.967 173.485L420.156 167l9.851 7.684 12.295 3.965-.069.038c4.941 1.714 10.581 4.211 12.295 5.817 1.852 1.721 5.494 4.165 2.551 13.624-1.875 6.04-10.066 36.654-10.066 36.654l-4.149-.768s1.475-17.735 2.951-31.006c.722-6.432.961-8.23.961-8.23s-27.41 2.989-36.239-1.675c-6.18-3.296-.57-14.677-.57-19.618z"
            transform="translate(-94.399 -38.672)"
            fill="url(#prefix__e)"
          />
          <path
            data-name="Path 11299"
            d="M352.906 193.829s-.123 1.114-1.906 1.614a3.074 3.074 0 01-3-.968l-.4 3.635 5.7 4.019h4.744l-2.559-2.843z"
            fill="#133a50"
          />
          <path
            data-name="Path 11300"
            d="M371.916 188.78a1.959 1.959 0 01-.707 2.582 3.02 3.02 0 01-3.151 0l.73 3.589 13.463-4.211z"
            fill="#133a50"
          />
          <path
            data-name="Path 11301"
            d="M356.409 98.099a28.781 28.781 0 01-2.243-2.672l-.515-2.344s-.907-1.214-1.606-1.944-1.322-3.842-1.322-3.842l.907-.546a11.423 11.423 0 00.722 1.714 1.652 1.652 0 00.884.361 16.907 16.907 0 000-2.182 18.916 18.916 0 00-.83-3.688l.768-.369a16.472 16.472 0 01.73 1.691c.161.53.438 1.629.438 1.629a18.057 18.057 0 00-.231-2.49 19.816 19.816 0 01-.307-1.66l.768-.207a15.858 15.858 0 01.53 2.013c.131.83.407 2.221.407 2.221a22.66 22.66 0 000-2.536 7.946 7.946 0 01-.077-.9h.845a6.671 6.671 0 01.3 1.913 8.805 8.805 0 00.085 1.537 9.364 9.364 0 00.231-2.075 1.836 1.836 0 010-.7l.653.108s.369 2.59.492 4.149-.077 3.542-.092 4.611-.038 1.967-.038 1.967z"
            fill="#fec4ad"
          />
          <path
            data-name="Path 11302"
            d="M339.151 101.118a101.8 101.8 0 0010.481 7.508s1.959-4.9 2.889-8.376c1.114-4.142 1.437-6.055 1.437-6.055l3.965-.323s-1.26 10.6-2.82 17.8c-1.537 6.993-3.419 5.748-5.095 5.379s-17.451-8.822-17.451-8.822l1.691-9.006s1.146-1.186 4.903 1.895z"
            fill="#fec4ad"
          />
          <path
            data-name="Path 11303"
            d="M322.476 75.653a9.965 9.965 0 017.469.768c4.879 3 2.543 11.234 2.236 13.132s1.445 5.31 1.414 7.577-.569 3.074-2.259 5.279a4.18 4.18 0 00-.63 1.744 16.137 16.137 0 01-2.267-6.685c-.4-3.9-1.229-2.989-3.181-7.269s-2.029-10.758-2.029-10.758z"
            fill="#471a16"
          />
          <path
            data-name="Path 11304"
            d="M326.58 78.443l-4.065-2.789a5.917 5.917 0 00-5.479 2.62c-2.013 3.074-2.713 7.546-3.166 10.9s-1.629 9.659-1.537 12.164 3.12 2.835 3.12 2.835l10.2-4.4a30.268 30.268 0 01-.092-11.081 55.446 55.446 0 001.022-10.251z"
            fill="#471a16"
          />
          <path
            data-name="Path 11305"
            d="M329.929 79.295a60.222 60.222 0 011.3 7.385c.1 2.39-.192 6.332-1.775 7.415s-4.557.223-6.731-.684a5.142 5.142 0 01-3.128-3.842c-.43-1.422-.277-5.125.223-7.8a4.757 4.757 0 014.157-4.111c1.966-.353 5.954 1.637 5.954 1.637z"
            fill="#fec4ad"
          />
          <path
            data-name="Path 11306"
            d="M321.04 88.186s.561 5.948-.692 8.745c-.861 1.929-4.357 2.743-4.357 2.743a19.7 19.7 0 003.373 10.5c3.512 5.156 14.469 7.069 14.469 7.069a47.728 47.728 0 003.273-9.137 10.658 10.658 0 00-1.929-8.553s-2.966-.968-4.388-1.537c-3.458-1.3-3.074-6.793-3.074-6.793z"
            fill="#fec4ad"
          />
          <path
            data-name="Path 11307"
            d="M327.699 101.964s-7.085-1.806-9.221-3.189l-7.023 4.2s-4.126 3.942 2.92 14.293c0 0 2.674 9.436-1.667 26.05 0 0 1.168 4.28 7.753 2.006 5.671-1.967 5.794-3.5 10.758-4.757 7.331-1.86 9.221-3 9.221-3-3.842-5.786-3.166-14.815-3.166-14.815s4.365-4.18 2.49-8.453c-2.7-6.147-3.6-14.884-3.6-14.884l-3.758-.953a28.815 28.815 0 01-3 3.2 1.621 1.621 0 01-1.707.302z"
            fill="#165a9f"
          />
          <path
            data-name="Path 11308"
            d="M330.791 98.053s-.861 3.212-3.074 3.911c0 0 .868 4.4 2.951 3.635 2.928-1.076 1.79-7.162 1.79-7.162z"
            fill="#fff"
          />
          <path
            data-name="Path 11309"
            d="M317.635 98.237s1.391 6.716 5.1 7.262 4.964-3.535 4.964-3.535-7.869-2.305-8.637-4.718z"
            fill="#fff"
          />
          <path
            data-name="Path 11310"
            d="M324.182 77.612c-.684.046-1.191 3.281-1.26 5.095s-2.774 3.227-1.583 7.2 1.037 7.815 2.636 12.172-.392 5.948-1.26 7.454a57.841 57.841 0 01-4.611-5.633 4.526 4.526 0 00-4.9-2.2s5.233-10.159 5.056-12.894-.661-6.916 1.537-9.421 4.385-1.773 4.385-1.773z"
            fill="#471a16"
          />
          <path
            data-name="Path 11311"
            d="M321.431 85.719s-1.46-1.591-2.421-1.352-1.014 1.683-.284 2.866 3.435 1.844 3.435 1.844z"
            fill="#fec4ad"
          />
          <path
            data-name="Path 11312"
            d="M324.735 82.615a18.774 18.774 0 004.126-.3 6.427 6.427 0 013.75.392l-1-4.388s-3.074-1.706-5.256-1.691c-2.774 0-5.2 1.076-3.842 1.975s2.222 4.012 2.222 4.012z"
            fill="#471a16"
          />
          <path
            data-name="Path 11313"
            d="M317.42 107.865c-.469 5.5-2.082 21.17-2.082 21.17 5 4.38 12.087 11.657 12.087 11.657s-2.021 3.98-2.882 3.3c-6.916-5.379-14.777-8.583-15.368-12.295-.922-6.147-1.245-21.67 1.03-26.71 1.774-3.922 7.714-2.954 7.215 2.878z"
            fill="#fec4ad"
          />
          <path
            data-name="Path 11314"
            d="M330.461 141.184c2.1.768 3.412 1.537 3.289 2.305-.085.538-1.875-.446-2.943-.407a5.971 5.971 0 002.543 2.5c1.383.676 2.159 1.629 1.422 2.428s-2.113 1.921-3 1.537-4.05-2.613-5.241-3.227-1.667-2.105-2.305-2.52 1.122-3.558 1.122-3.558c.33.085 2.059.453 2.059.453a10.579 10.579 0 001.714.146 4.072 4.072 0 011.345.346z"
            fill="#fec4ad"
          />
          <path
            data-name="Line 329"
            fill="none"
            stroke="#194459"
            strokeMiterlimit={10}
            d="M0 246.22h468.361"
          />
        </g>
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
